module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-challenge-float01.jpg?h=ee99bbbaabc4ef999d484ac6d6a45d96";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-challenge-float01.jpg
// module id = 2123
// module chunks = 12 15